<template>
  <div class="NotificationConfigurationView">
    <PageHeader title="Ustawienia powiadomień" />
    <ShPageLayout>
      <NotificationsList />
    </ShPageLayout>
  </div>
</template>

<script>
import ShPageLayout from '@/components/Helpers/ShPageLayout';
import PageHeader from '@/components/Common/PageHeader';
import NotificationsList from '@/components/Notifications/NotificationsList';


export default {
  name: 'NotificationConfiguration',

  components: {
    PageHeader,
    ShPageLayout,
    NotificationsList,
  },
};
</script>
